<script setup lang="ts">
import { ref } from 'vue'
import { type Journey } from '~/types/fptfTypes'
import JourneyLegs from '~/components/JourneyDisplay/JourneyLegs.vue'
import JourneyHeader from '~/components/JourneyDisplay/JourneyHeader.vue'
import RefreshJourneyButton from '~/components/JourneyDisplay/RefreshJourneyButton.vue'

const { showHeader = false, showRefreshButton = true } = defineProps<{
  journey: Journey
  showHeader?: boolean
  showRefreshButton?: boolean
}>()

const showLegs = ref(false)
</script>

<template>
  <div class="pointer-cursor card bg-dark my-3">
    <div v-if="showHeader" class="card-header p-2 d-flex" @click="showLegs = !showLegs">
      <div class="d-flex gap-2 flex-wrap">
        <b>{{ journey.legs[0].origin.name }}</b>
        <i class="icon icon-arrow-right"></i>
        <b>{{ journey.legs.at(-1).destination.name }}</b>
      </div>
      <refresh-journey-button
        v-if="showRefreshButton"
        class="ms-auto align-self-start"
        :refresh-token="journey.refreshToken"
      ></refresh-journey-button>
    </div>
    <journey-header
      @click="showLegs = !showLegs"
      class="card-body p-0"
      :journey="journey"
    ></journey-header>
    <transition name="open">
      <journey-legs :journeyLegs="journey.legs" v-if="showLegs"></journey-legs>
    </transition>
  </div>
</template>

<style lang="scss">
.open-enter-active,
.open-leave-active {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 0.3s;
}

.open-enter-from,
.open-leave-to {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s;
}
</style>
